/**
 * Utility to wait for all InlineSVGProjection components to finish loading.
 *
 * InlineSVGProjection renders a placeholder div with backgroundColor rgba(200, 200, 200, 0.2)
 * while fetching SVGs. Once loaded, it replaces the placeholder with the actual SVG content
 * via dangerouslySetInnerHTML. On error, it shows '!' text.
 *
 * This poller checks for remaining loading placeholders and resolves when all are done.
 */
export function waitForSVGsToLoad(
  container,
  { maxWaitMs = 5000, pollIntervalMs = 50 } = {}
) {
  return new Promise((resolve) => {
    const startTime = Date.now();

    const check = () => {
      // Find InlineSVGProjection loading placeholders
      // These have backgroundColor rgba(200, 200, 200, 0.2) and no <svg> child
      const placeholders = container.querySelectorAll(
        'div[style*="rgba(200, 200, 200, 0.2)"]'
      );
      const stillLoading = Array.from(placeholders).filter(
        (el) => !el.querySelector('svg') && !el.textContent.includes('!')
      );

      if (stillLoading.length === 0 || Date.now() - startTime > maxWaitMs) {
        if (stillLoading.length > 0) {
          console.warn(
            `[svgLoadPoller] Timed out with ${stillLoading.length} SVGs still loading`
          );
        }
        // One more frame for final paint
        requestAnimationFrame(() => resolve());
        return;
      }

      setTimeout(check, pollIntervalMs);
    };

    // Initial delay to let React render
    setTimeout(check, 100);
  });
}
